import { DialogContent, DialogTitle } from "@mui/material";
import { useCallback, type ReactNode } from "react";

import { zIndexes } from "../utilities";
import { ConfirmationDialogButtons } from "./ConfirmationDialogButtons";
import type { ModalDialogProps } from "./ModalDialog";
import { ModalDialog } from "./ModalDialog";

type ConfirmationDialogProps = ModalDialogProps & {
  header: ReactNode;
  message: ReactNode;
  cancelLabel: ReactNode;
  confirmLabel: ReactNode;
  onConfirm: (confirmed: boolean) => void;
};

export const ConfirmationDialog = ({
  header,
  message,
  cancelLabel,
  confirmLabel,
  onConfirm,
  open,
  ...modalProps
}: ConfirmationDialogProps) => {
  const buttons = (
    <ConfirmationDialogButtons cancelLabel={cancelLabel} confirmLabel={confirmLabel} onConfirm={onConfirm} />
  );

  const handleCancel = useCallback(() => onConfirm(false), [onConfirm]);

  return (
    <ModalDialog
      open={open}
      buttons={buttons}
      onClose={handleCancel}
      sx={{ zIndex: zIndexes.triggersOverlayPopover + 1 }}
      {...modalProps}
    >
      <DialogTitle>{header}</DialogTitle>
      <DialogContent>{message}</DialogContent>
    </ModalDialog>
  );
};
